export default "__VITE_ASSET__HmuyDDca__"